import { SocialItemPlatform } from '../enums/social-item-platform.enum';
import { SocialItem } from '../types/social-item.type';

export const contactInfo = {
  organization: 'Klubovňa o.z.',
  address: {
    street: 'Nám. sv. Mikuláša 23/23',
    city: 'Stará Ľubovňa',
    postalCode: '06401',
    country: 'Slovensko',
  },
  ico: '56308248',
  email: 'info@klubovnasl.sk',
  phone: '+421 952 185 504',
};

export const socialItems: SocialItem[] = [
  {
    platform: SocialItemPlatform.IG,
    handle: '@klubovnasl',
    link: 'https://www.instagram.com/klubovnasl/',
    icon: '/images/ig.svg',
  },
  {
    platform: SocialItemPlatform.FB,
    handle: 'KLubovňa',
    link: 'https://www.facebook.com/profile.php?id=61569598487293',
    icon: '/images/fb.svg',
  },
  {
    platform: SocialItemPlatform.DC,
    handle: '(k)Lubovna',
    link: 'https://discord.gg/7Bwgqw77rq',
    icon: '/images/discord.svg',
  },
  {
    platform: SocialItemPlatform.YT,
    handle: '@klubovňaSL',
    link: 'https://www.youtube.com/@klubovňaSL',
    icon: '/images/yt.svg',
  },
];
